import React from 'react';
import { useDispatch } from 'react-redux';

import {
  COLOURFUL_TEMPLATE_NAME,
  COMMENT_FEASIBILITY,
} from '../../../utils/const';
import SectionHeader from '../../../components/SectionHeader';
import PortfolioCommentIcon from '../../../components/PortfolioCommentIcon';
import SvgIcon from '../../../components/SvgIcon';

const Feasibility = ({
  data: { description },
  locales: { portfolio },
  className,
  backgroundSection,
  sectionHeaderTitleColor,
  descriptionColor,
  mainSvgColor,
  templateName,
  disabled = false,
}) => {
  const {
    portfolio: { updateSectionField },
  } = useDispatch();

  return (
    <div
      className={`${className} relative`}
      style={{ backgroundColor: backgroundSection }}
    >
      <PortfolioCommentIcon title={COMMENT_FEASIBILITY} />
      {templateName === COLOURFUL_TEMPLATE_NAME && (
        <div className="svg-funFeasibility" style={{ fill: mainSvgColor }}>
          <SvgIcon name="funFeasibility" />
        </div>
      )}
      <SectionHeader
        templateName={templateName}
        title={portfolio.feasibility.newSectionName}
        description={description}
        onChange={(e) =>
          updateSectionField({
            sectionName: 'feasibility',
            field: 'description',
            name: 'feasibilityText',
            value: e.target.value,
          })
        }
        portfolio={portfolio}
        style={{ color: sectionHeaderTitleColor }}
        descriptionColor={descriptionColor}
        disabled={disabled}
      />
    </div>
  );
};

export default Feasibility;
